<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag" [dragula]='"widget-bag"'>
    <swb-logo></swb-logo>
</div>
<div class="grid__cell grid__cell--widget grid__cell--widget-dashboard widget__bag" [dragula]='"widget-bag"'>
    <swb-favicon></swb-favicon>
    <swb-favicon-ico></swb-favicon-ico>
</div>
<router-outlet></router-outlet>